import { GlobalPointerEventCapturer } from '@tableau/widgets';
import * as React from 'react';

export type FilterPanelResizeState = { filterPanelWidth: number, filterPanelCurrentlyResizing: boolean };

const cancelEvent: EventListener = e => e.preventDefault();
const ignoreTouchEvents = (ref: HTMLDivElement | null) => ref?.addEventListener('touchstart', cancelEvent, { passive: false });

export const FilterPanelResizer: React.FC<{ setResizing: (resizing: boolean) => void, setPanelWidth: (width: number) => void }> = ({ setResizing, setPanelWidth }) => {
  const filterPanelResizerEventCapturer = React.useMemo(() => new GlobalPointerEventCapturer(
    (mouseMoveEvent: MouseEvent) => {
      mouseMoveEvent.preventDefault();
      setPanelWidth(document.documentElement.clientWidth - mouseMoveEvent.clientX);
    },
    () => { // cleanup func
      document.body.style.cursor = '';
      filterPanelResizerEventCapturer.removeListeners();
      setResizing(false);
    }
  ), [setPanelWidth, setResizing]);

  return <div
    data-tb-test-id={FilterPanelResizerTestId}
    ref={ignoreTouchEvents} // we don't want tap-and-drag to be a resize gesture for touch devices
    role='none'
    style={{ position: 'absolute', top: 0, left: 0, bottom: 0, width: 4, cursor: 'ew-resize' }}
    onMouseDown={e => {
      if (e.currentTarget !== e.target) { return; }

      e.preventDefault();
      e.stopPropagation();

      document.body.style.cursor = 'ew-resize';
      filterPanelResizerEventCapturer.addListeners();
      setResizing(true);
    }}
  />;
};
FilterPanelResizer.displayName = 'FilterPanelResizer';
export const FilterPanelResizerTestId = 'filter-panel-resizer';